/* eslint-disable react/no-unescaped-entities */
import React, { FC, useState } from 'react';

import { getLocalValue, setLocalItem } from '../../../utils/services/storage';
import {
  Box,
  FormControl,
  Select,
  MenuItem,
  Typography,
  SelectChangeEvent,
} from '@mui/material';
import { LOCATION, UserType } from '../../../utils/constants';
import { useNavigate } from 'react-router-dom';
import licensedStates from 'utils/constants/states';
import { useAuth } from 'utils/contexts/auth-context';
import MainButton from 'shared/components/button/main-button.component';
import { useAuth0 } from '@auth0/auth0-react';

const SelectLocation: FC = () => {
  const navigate = useNavigate();
  const { isAuthenticated, user } = useAuth0();
  const sorenson_user = getLocalValue('sorenson_user');

  const { setLocation, setUserData } = useAuth();
  const [locationState, setLocationState] = useState<string>(
    licensedStates[0].value
  );

  const handleOnChange = ({ target }: SelectChangeEvent<string>) => {
    setLocationState(target.value);
  };

  const handleSubmit = () => {
    setLocation(locationState);
    setLocalItem<string>(LOCATION, JSON.stringify(locationState));
    navigate('/', { replace: true });
  };

  React.useEffect(() => {
    if (isAuthenticated) {
      setUserData(user?.name || '', 0, UserType.VRI, user?.email);
    }
  }, [isAuthenticated, sorenson_user, user]);

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
      }}
      id='select-location-page'
    >
      <Typography
        id='select-location-page-text'
        sx={{
          alignSelf: 'center',
          fontSize: '16px',
          marginBottom: '15px',
          marginLeft: '20px',
          width: '70%',
          color: 'secondary.contrastText',
        }}
      >
        Sorenson for Zoom brings live American Sign Language (ASL) interpreters
        to any meeting.
      </Typography>
      <Typography
        id='select-location-page-requestor-location'
        sx={{ fontSize: '18px', fontWeight: '600', marginBottom: '15px' }}
      >
        The requestor for sign language interpreting services is located in
      </Typography>
      <Box
        id='select-location-container'
        sx={{
          display: 'flex',
          flexDirection: 'column',
        }}
      >
        <FormControl fullWidth id='select-location-form'>
          <Select
            labelId='location-select-label'
            id='location-select'
            value={locationState}
            onChange={handleOnChange}
            MenuProps={{
              sx: {
                '.MuiList-root': {
                  bgcolor: 'white',
                  border: '1px solid',
                  borderColor: 'info.contrastText',
                },
              },
            }}
            sx={{
              marginBottom: '20px',
              borderRadius: '8px',
              '.MuiSelect-select': {
                backgroundColor: '#fff',
              },
            }}
          >
            {licensedStates.map(({ value, name }) => (
              <MenuItem id='select-location-options' value={value} key={value}>
                <Box id={`select-location-${value}`}>{name}</Box>
              </MenuItem>
            ))}
          </Select>
        </FormControl>
        <Typography
          id='select-location-state'
          sx={{
            fontSize: '14px',
            fontWeight: '400',
            marginBottom: '15px',
            color: 'grey.600',
          }}
        >
          Choose the state where you are located
        </Typography>
      </Box>
      <Box sx={{ width: '100%' }}>
        <MainButton
          onClick={handleSubmit}
          type='submit'
          id='select-location-button'
        >
          Continue
        </MainButton>
      </Box>
    </Box>
  );
};

export default SelectLocation;
